/*
* Text Input Component
* */
import React, { useEffect, useState, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {randomIdentifier} from "../../../utils/helpers";
import LazyLoadImg from '../LazyLoadImg';
import SkeletonLoadingComponent from '../SkeletonLoading';

type Props = {
    id: String,
    name: String,
    value: String,
    style: any,
    path: String,
    checked: boolean,
    handleChange: Function,
    mutiple: Boolean,
    data: Object,
    customClass: String,
    state: String,
    disabled: Boolean,
    marker: Boolean
};


const PhotoSelector = ({
        id,
        name,
        value,
        style,
        path,
        checked,
        handleChange,
        mutiple,
        data,
        customClass,
        state,
        disabled,
        marker
    }: Props) => {

    const [isChecked, setIsChecked] = useState(checked);
    useEffect(() => {
        if(isChecked != checked)
            setIsChecked(!isChecked);
    }, [checked])
    
    const _handleChange = (e) => {
        console.log(e.target.value, '_handleChange');
        if(typeof handleChange == 'function') handleChange(e, value, data)
        // setIsChecked(!isChecked)
    }
    return (
        <label className={`photo-selector ${customClass} ${isChecked ? 'active': 'inactive'}`}>
            <input
                type={mutiple ? 'checkbox' : 'radio'}
                id={id}
                name={name}
                checked={isChecked}
                value={value} 
                onClick={_handleChange}
                onChange={()=>{}}
                disabled={disabled}
            />
            <div className={`photo-selector__thumb ${customClass}`}>
                <LazyLoadImg src={path || ""} />
                {/* <img className="photo" src={path} alt=""/> */}
                {
                    marker && <div className="marker">
                    <img src="/images/icon_checkmark_big.svg" alt=""/>
                </div>
                }
            </div>
        </label>
    );
};

PhotoSelector.defaultProps = {
    id: "js-"+ randomIdentifier(),
    name: "input-"+ randomIdentifier(),
    value: "",
    style: false,
    path: "",
    checked: false,
    handleChange: ()=>{},
    mutiple: true,
    customClass: '',
    state: 'active',
    disabled: false,
    marker: true,
};

export default memo(PhotoSelector);
